import { render, staticRenderFns } from "./commentHander.vue?vue&type=template&id=20048f74&scoped=true"
import script from "./commentHander.vue?vue&type=script&lang=js"
export * from "./commentHander.vue?vue&type=script&lang=js"
import style0 from "./commentHander.vue?vue&type=style&index=0&id=20048f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20048f74",
  null
  
)

export default component.exports